<template>
  <div class="list">
    <v-row>
      <v-col md="3">
        <MacroMetricItem
          title="Minimum Estimated Digital Risk"
          description="The lower threshold of the estimated economic impact based on the scope of the data scanned by Reveles and the selected cost study."
          :valueCurrent="minEDR"
          :valuePrev="prevMinEDR"
          :difference="''"
          :valueSign="'$'"
          :loading="riskEnterpriseLoading"
          has-info
        >
          <div slot-scope="value" slot="value">
            {{value.sign + numberWithCommas(value.current)}}
          </div>
        </MacroMetricItem>
      </v-col>
      <v-col md="3">
        <MacroMetricItem
          title="Maximum Estimated Digital Risk"
          description="The upper threshold of the estimated economic impact based on the scope of the data scanned by Reveles and the selected cost study."
          :valueCurrent="maxEDR"
          :valuePrev="prevMaxEDR"
          :valueSign="'$'"
          :difference="''"
          :loading="riskEnterpriseLoading"
          has-info
        >
          <div slot-scope="value" slot="value">
            {{value.sign + numberWithCommas(value.current)}}
          </div>
        </MacroMetricItem>
      </v-col>
      <v-col md="3">
        <MacroMetricItem
          title="Digital Identities"
          description="The number of distinct digital identities across all systems scanned by Reveles e.g. Jane's financial information is stored in the accounting system and her contact information is stored in our marketing database. Both of those digital fragments of Jane are resolved into a single digital identity."
          :valueCurrent="resolvedIdentities"
          :valuePrev="prevResolvedIdentities"
          :difference="''"
          :loading="riskEnterpriseLoading"
        >
          <div slot-scope="value" slot="value">
            {{value.sign + numberWithCommas(value.current)}}
          </div>
        </MacroMetricItem>
      </v-col>
      <v-col md="3">
        <MacroMetricItem
          title="@Risk for Regulation"
          description="The subset of digital identities that can claim the benefit of a data protection regulation such as GDPR, CCPA, or NY Shield."
          :valueCurrent="riskRegulation"
          :valuePrev="prevRiskRegulation"
          :difference="''"
          :loading="riskEnterpriseLoading"
        >
          <div slot-scope="value" slot="value">
            {{value.sign + numberWithCommas(value.current)}}
          </div>
        </MacroMetricItem>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { formatNumber } from '../utils'
import MacroMetricItem from './MacroMetricItem'

export default {
  name: 'MacroMetricList',
  components: {
    MacroMetricItem
  },
  computed: {
    ...mapGetters(['currentOrganization']),
    ...mapState('dashboardServices', ['riskEnterpriseData', 'riskEnterpriseLoading', 'riskEnterpriseDateIndex']),
    indexOfLastMonth () {
      if (this.riskEnterpriseDateIndex || this.riskEnterpriseDateIndex === 0) {
        return this.riskEnterpriseDateIndex
      }
      const m = this.riskEnterpriseData?.date && this.$moment.max(this.riskEnterpriseData.date.map(date => { return this.$moment(date, 'YYYY-MM-DD') }))._i
      return this.riskEnterpriseData?.date?.indexOf(m)
    },
    minEDR () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.data_risk_min[this.indexOfLastMonth] : ''
    },
    maxEDR () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.data_risk_max[this.indexOfLastMonth] : ''
    },
    resolvedIdentities () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.resolved_identities[this.indexOfLastMonth] : ''
    },
    riskRegulation () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.regulation_identities[this.indexOfLastMonth] : ''
    },

    prevMinEDR () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.data_risk_min[this.indexOfLastMonth - 1] : ''
    },
    prevMaxEDR () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.data_risk_max[this.indexOfLastMonth - 1] : ''
    },
    prevResolvedIdentities () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.resolved_identities[this.indexOfLastMonth - 1] : ''
    },
    prevRiskRegulation () {
      return this.indexOfLastMonth !== undefined ? this.riskEnterpriseData.regulation_identities[this.indexOfLastMonth - 1] : ''
    }
  },
  methods: {
    numberWithCommas (x) {
      const count = String((+x).toFixed()).length
      if (count === 6) {
        return Math.floor(x / 1000) + 'K'
      } else if (count >= 7 && count <= 9) {
        return (x / 1000000).toFixed(9 % count) + 'M'
      } else if (count >= 10 && count <= 12) {
        return (x / 1000000000).toFixed(12 % count) + 'B'
      } else if (count >= 13 && count <= 15) {
        return (x / 1000000000000).toFixed(15 % count) + 'T'
      } else if (count > 15) {
        return (x / 1000000000000).toFixed(0) + 'T'
      }
      return formatNumber((+x).toFixed())
    }
  }
}
</script>

<style scoped>
  .list {
    margin: 0 0 15px 0;
  }
</style>
